import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#0A0E1A] text-white flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20 lg:pt-24">
        <Outlet />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
